// step modifier

export const stepModifier: Record<string, number[]> = {
    Learning: [0.85, 0.94],
    Established: [0.95, 1.04],
    Thriving: [1.05, 1.1],
    Expert: [1.11, 1.2],
}
